import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
const useStyles = makeStyles({
  // As the Bills page: the page grows with its content and the app's page container scrolls it.
  pageWrapper: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1 0 auto',
    paddingTop: '12px',
    backgroundColor: palette.shades[100],
    borderTop: "1px solid ".concat(palette.shades[300])
  },
  pageHeader: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '8px 16px',
    padding: '4px 16px 12px'
  },
  title: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: '8px',
    minWidth: 0
  },
  contentWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    padding: '8px 16px 16px',
    minWidth: 0
  },
  lead: {
    maxWidth: '72ch'
  },
  toolbar: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: '8px 16px'
  },
  typeFilter: {
    minWidth: '200px'
  },
  // The list, framed as the Bills page frames its table.
  panel: {
    overflow: 'hidden',
    backgroundColor: '#FFFFFF',
    border: "1px solid ".concat(palette.shades[300]),
    borderRadius: 8,
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.06)'
  },
  // On a narrow screen the table scrolls inside its frame; the page never does.
  tableScroll: {
    overflowX: 'auto'
  },
  table: {
    minWidth: '980px',
    '& th': {
      fontWeight: 600,
      whiteSpace: 'nowrap',
      backgroundColor: palette.shades[100]
    },
    '& td': {
      verticalAlign: 'top'
    }
  },
  // A row with its pending edit, hidden-properties note or history under it: one line under both.
  withDetail: {
    '& td': {
      borderBottom: 'none'
    }
  },
  detailCell: {
    paddingTop: 0
  },
  detail: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    minWidth: 0
  },
  detailLine: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: '4px 8px'
  },
  setupName: {
    fontWeight: 600,
    overflowWrap: 'anywhere'
  },
  value: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: '4px 6px'
  },
  needs: {
    display: 'inline-flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: '4px'
  },
  actions: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'flex-end',
    gap: '4px'
  },
  history: {
    maxWidth: '72ch'
  },
  note: {
    maxWidth: '72ch'
  },
  // The actions column's header: read out, not shown.
  visuallyHidden: {
    position: 'absolute',
    width: 1,
    height: 1,
    padding: 0,
    margin: -1,
    overflow: 'hidden',
    clip: 'rect(0 0 0 0)',
    whiteSpace: 'nowrap',
    border: 0
  },
  dialogBody: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px'
  },
  archivedToggle: {
    alignSelf: 'flex-start'
  }
});
export default useStyles;